@if (fundReport$ | async; as fundReportDetail) {
    <mat-card class="detail-card" valumizeCardContextMenu [commentScope]="'fund-report'" [commentSlug]="'fund-report-details'">
        @if ((fundReport$ | async)?.fundReport?.data?.id; as fundReportId) {
            @if (reportDate$ | async; as reportDate) {
                <mat-card-header class="detail-card-header">
                    <mat-card-title data-test="title">Fund Report Details as of {{ reportDate | traceableFormat }}</mat-card-title>
                </mat-card-header>
            }
            <mat-card-content class="detail-card-content">
                <form [formGroup]="fundReportDetailFormGroup">
                    <div class="key-value-pair-section">
                        <div class="key-value-pair-column" style="flex: 1;">
                            <div class="key-value-pair">
                                <div class="key-value-item">Total Of Unrealized Assets</div>
                                <div class="key-value-item">
                                    {{ fundReportDetail.fundReport.data.totalOfUnrealizedAssets | traceableFormat }}
                                </div>
                            </div>
                            <valumize-mergeable-number-input
                                [label]="'Net Current Assets'"
                                [isEditable]=fundReportDetail.fundReportDetailsIsEditable
                                [isDataset]=isDataset
                                [value]=fundReportDetail.fundReport.data.netCurrentAssets
                                [baselineValue]=baselineReport.netCurrentAssets
                                [control]=fundReportDetailFormGroup.controls.netCurrentAssets
                                [type]="'currency'"
                                (valueChange)="triggerCalculation()">
                            </valumize-mergeable-number-input>
                            <valumize-mergeable-number-input
                                [label]="'GP Carry Reserve'"
                                [isEditable]=fundReportDetail.fundReportDetailsIsEditable
                                [isDataset]=isDataset
                                [value]=fundReportDetail.fundReport.data.gpCarryReserve
                                [baselineValue]=baselineReport.gpCarryReserve
                                [control]=fundReportDetailFormGroup.controls.gpCarryReserve
                                [type]="'currency'"
                                [ngStyle]="{'border-bottom': '1px solid black'}"
                                (valueChange)="triggerCalculation()">
                            </valumize-mergeable-number-input>
                            <div class="key-value-pair">
                                <div class="key-value-item">Total Calculated NAV</div>
                                <div class="key-value-item">
                                    {{ fundReportDetail.fundReport.data.totalNav | traceableFormat }}
                                </div>
                            </div>
                            <div class="spacer"></div>
                            <valumize-mergeable-number-input
                                [label]="'Total Reported NAV'"
                                [isEditable]=fundReportDetail.fundReportDetailsIsEditable
                                [isDataset]=isDataset
                                [value]=fundReportDetail.fundReport.data.totalReportedNav
                                [baselineValue]=baselineReport.totalReportedNav
                                [control]=fundReportDetailFormGroup.controls.totalReportedNav
                                [type]="'currency'"
                                [anchorId]="'field-totalReportedNav'"
                                [isMandatory]="((isTopDown$ | async) ?? false) && true">
                            </valumize-mergeable-number-input>
                            <div class="spacer"></div>
                            <valumize-mergeable-number-input
                                [label]="'Total Drawdown'"
                                [isEditable]=fundReportDetail.fundReportDetailsIsEditable
                                [isDataset]=isDataset
                                [value]=fundReportDetail.fundReport.data.totalDrawDowns
                                [baselineValue]=baselineReport.totalDrawDowns
                                [control]=fundReportDetailFormGroup.controls.totalDrawDowns
                                [type]="'currency'"
                                [anchorId]="'field-totalDrawDowns'"
                                [isMandatory]="true"
                                (valueChange)="triggerCalculation()">
                            </valumize-mergeable-number-input>
                            <div class="spacer"></div>
                            <div class="key-value-pair">
                                <div class="key-value-item">
                                    Calculated Undrawn
                                    <mat-icon
                                        class="info-icon"
                                        matTooltip="Calculated Undrawn = Commitments − Drawdowns"
                                        matTooltipPosition="right">
                                        info_outline
                                    </mat-icon>
                                </div>
                                <div class="key-value-item">
                                    {{ fundReportDetail.fundReport.data.calculatedUndrawn | traceableFormat }}
                                </div>
                            </div>
                            <valumize-mergeable-number-input
                                [label]="'Recallable Distributions'"
                                [isEditable]=fundReportDetail.fundReportDetailsIsEditable
                                [isDataset]=isDataset
                                [value]=fundReportDetail.fundReport.data.recallableDistributions
                                [baselineValue]=baselineReport.recallableDistributions
                                [control]=fundReportDetailFormGroup.controls.recallableDistributions
                                [type]="'currency'"
                                [ngStyle]="{'border-bottom': '1px solid black'}"
                                (valueChange)="triggerCalculation()">
                            </valumize-mergeable-number-input>
                            <div class="key-value-pair">
                                <div class="key-value-item">Total Undrawn</div>
                                <div class="key-value-item">
                                    {{ fundReportDetail.fundReport.data.totalUndrawn | traceableFormat }}
                                </div>
                            </div>
                            <div class="spacer"></div>
                            <valumize-mergeable-number-input
                                [label]="'Total Distributions'"
                                [isEditable]=fundReportDetail.fundReportDetailsIsEditable
                                [isDataset]=isDataset
                                [value]=fundReportDetail.fundReport.data.totalDistributions
                                [baselineValue]=baselineReport.totalDistributions
                                [control]=fundReportDetailFormGroup.controls.totalDistributions
                                [type]="'currency'"
                                [anchorId]="'field-totalDistributions'"
                                [isMandatory]="true"
                                (valueChange)="triggerCalculation()">
                            </valumize-mergeable-number-input>
                            <div class="key-value-pair">
                                <div class="key-value-item">
                                    Current TVPI
                                    @if (!fundReportDetail.fundReportDetailsIsEditable) {
                                        <span class="nav-indicator">({{ fundReportDetail.fundReport.data.tvpiNavType.code === 'REPORTED' ? 'Reported' : 'Calculated' }} NAV)</span>
                                    }
                                    @if (fundReportDetail.fundReportDetailsIsEditable) {
                                        <select [formControl]="fundReportDetailFormGroup.controls.tvpiNavType"
                                                (change)="triggerCalculation()"
                                                class="tvpi-nav-select">
                                            <option value="CALCULATED">Using Calculated NAV</option>
                                            <option value="REPORTED" [disabled]="!isReportedNavAvailable">
                                                Using Reported NAV{{ !isReportedNavAvailable ? ' (N/A)' : '' }}
                                            </option>
                                        </select>
                                    }
                                </div>
                                <div class="key-value-item">{{ displayedTVPI | traceableFormat }}</div>
                            </div>
                            <valumize-mergeable-number-input
                                [label]="'Carry Paid to Date'"
                                [isEditable]=fundReportDetail.fundReportDetailsIsEditable
                                [isDataset]=isDataset
                                [value]=fundReportDetail.fundReport.data.carryPaidToDate
                                [baselineValue]=baselineReport.carryPaidToDate
                                [control]=fundReportDetailFormGroup.controls.carryPaidToDate
                                [type]="'currency'">
                            </valumize-mergeable-number-input>
                        </div>
                    </div>
                </form>
            </mat-card-content>
            <mat-card-actions class="detail-card-actions">
                @if (!fundReportDetail.fundReportDetailsIsEditable) {
                    <button (click)="edit()"
                            [disabled]="(isEditDisabled$ | async)!"
                            color="primary"
                            data-test="edit-button"
                            mat-icon-button>
                        <mat-icon>edit</mat-icon>
                    </button>
                }
                @if (fundReportDetail.fundReportDetailsIsEditable) {
                    <button (click)="save()" [disabled]="fundReportDetailFormGroup.invalid" color="primary" data-test="save-button"
                            mat-icon-button>
                        <mat-icon>save</mat-icon>
                    </button>
                }
                @if (fundReportDetail.fundReportDetailsIsEditable) {
                    <button (click)="cancel()" color="primary" data-test="cancel-button" mat-icon-button>
                        <mat-icon>cancel</mat-icon>
                    </button>
                }
                <valumize-card-comments-button [commentScope]="'fund-report'" [commentSlug]="'fund-report-details'"></valumize-card-comments-button>
            </mat-card-actions>
        } @else {
            <mat-card-header class="detail-card-header">
                <mat-card-title data-test="title">Fund Report Details</mat-card-title>
            </mat-card-header>
            <mat-card-content class="detail-card-content" style="color: grey">
                Please select fund report first!
            </mat-card-content>
        }
    </mat-card>
}
